import React from 'react';
import T from 'prop-types';
// components
import Form from '../../../components/Form/Form';
import { Link } from 'react-router-dom';
import FieldError from '../../../components/Form/FieldError';
import FormErrors from '../../../components/Form/FormErrors';
import Input from '../../../components/Input/Input';
import PasswordInput from '../../../components/PasswordInput/PasswordInput';
import Button from '../../../components/Button/Button';
// utils
import { withFormik } from 'formik';
import * as yup from 'yup';
import { responseData, responseErrors } from '../../../utils/response';
import { getUserRedirectPath } from '../../../utils/authHelper';
// styles
import styles from '../LogIn.mod.css';

export const LogInForm = ({
  values,
  touched,
  errors = {},
  dirty,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
}) => (
  <Form className={styles.formWrapper} onSubmit={handleSubmit}>
    <h2 className={styles.title}>Log In</h2>
    <FormErrors errors={errors} />

    <div className="form-control">
      <div className="field-wrapper">
        <Input
          name="email"
          placeholder="Email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.email && touched.email}
        />
        <FieldError error={errors.email} touched={touched.email} />
      </div>
    </div>
    <div className="form-control">
      <div className="field-wrapper">
        <PasswordInput
          name="password"
          placeholder="Password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.password && touched.password}
        />
        <FieldError error={errors.password} touched={touched.password} />
        <Link className={styles.recover} to="/password-recovery">
          Forgot Password
        </Link>
      </div>
    </div>
    <div className={styles.buttons}>
      <Button
        type="submit"
        primary
        isLoading={isSubmitting}
        disabled={isSubmitting}
      >
        Log In
      </Button>
      <Link className={styles.link} to="/signup">
        Create account
      </Link>
    </div>
  </Form>
);

LogInForm.propTypyes = {
  onSubmit: T.func.isRequired,
};

export default withFormik({
  mapPropsToValues: () => ({ email: '', password: '' }),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: yup.object().shape({
    email: yup
      .string()
      .email('Invalid email address')
      .required('Email is required!'),
    password: yup.string().required('Password is required!'),
  }),
  handleSubmit: (
    values,
    { props: { onSubmit, redirect }, setSubmitting, setErrors }
  ) => {
    return onSubmit(values)
      .then(({ value }) => {
        setSubmitting(false);
        const user = responseData(value, 'resource');
        // const redirectPath = getUserRedirectPath(user);
        const redirectPath = '/dashboard';
        redirect(redirectPath);
      })
      .catch(response => {
        setErrors(responseErrors(response));
        setSubmitting(false);
      });
  },
  displayName: 'LogInForm',
})(LogInForm);



// WEBPACK FOOTER //
// ./src/containers/LogIn/components/LogInForm.jsx